module.exports = __webpack_public_path__ + "mo/img/piece-25.c35493a6.svg";